import { useMutation } from '@tanstack/react-query';

export function useCreateProjectsReviewsBulkReminderMutation({ projectId }) {
  return useMutation({
    mutationFn: async () => {
      const response = await axios.post(
        `/projects/${projectId}/reviews/bulk_reminders`,
      );

      return response.data;
    },
  });
}
